import { render, staticRenderFns } from "./price-form.vue?vue&type=template&id=45c0427c&scoped=true&"
import script from "./price-form.vue?vue&type=script&lang=js&"
export * from "./price-form.vue?vue&type=script&lang=js&"
import style0 from "./price-form.vue?vue&type=style&index=0&id=45c0427c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c0427c",
  null
  
)

export default component.exports